import LensCare from '../components/lensCare';

export default LensCare;